export enum UserRole {
  AcadAdmin = 'ROLE_ACAD_ADMIN',
  SysAdmin = 'ROLE_SYS_ADMIN',
  Monitor = 'ROLE_MONITOR',
  User = 'ROLE_USER',
  TeacherAdmin = 'ROLE_TEACHER_ADMIN',
  Teacher = 'ROLE_TEACHER',
}
